module.exports = __webpack_public_path__ + "img/icon_comments.82a1952b.png";